import React, { useEffect, useState } from "react";
// import { DataStore } from '@aws-amplify/datastore';
import { USER } from "../../../models";
// Stylesheet
import "./EditProfile.css";
import { toast } from "react-hot-toast";
// Popup
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import PreloaderInner from "./../../../components/preloader/loader";

// Material UI Icons
import EditIcon from "@mui/icons-material/Edit";
import DragDrop from "../../../components/dragDrop/DragDrop";
import firebase from "./../../../firebase";

function EditProfile({ account, setUpdated }) {
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [instagram, setInstagramLink] = React.useState();
  const [isSubmited, setSubmited] = useState(false);
  const [twitter, setTwitterLink] = React.useState();
  const [youtube, setYoutubeLink] = React.useState();
  const [name, setName] = React.useState();
  const [file, setFile] = React.useState();
  const [username, setUserName] = React.useState();
  const [email, setEmail] = React.useState();
  const [image, setImage] = React.useState();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (account && open) {
      setLoader(true);
      await firebase
        .firestore()
        .collection("UserDataModel")
        .limit(1)
        .where("walletAddress", "==", `${account}`)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            const userDetail = doc.data();
            console.log(userDetail);
            if (userDetail.name) setName(userDetail.name);
            if (userDetail.username) setUserName(userDetail.username);
            if (userDetail.email && userDetail.email !== "no_email")
              setEmail(userDetail.email);
            if (userDetail.instagram) setInstagramLink(userDetail.instagram);
            if (userDetail.twitter) setTwitterLink(userDetail.twitter);
            if (userDetail.youtube) setYoutubeLink(userDetail.youtube);
            if (userDetail.imageURL) {
              setImage(userDetail.imageURL);
              var output = document.getElementById("imgSelectionProfile");
              output.src = userDetail.imageURL;
            }
            setLoader(false);
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
          setLoader(false);
        });
    }
  }, [open]);

  const userExists = async() => {
    await firebase
      .firestore()
      .collection("UserDataModel")
      .limit(1)
      .where("username", "==", `${username}`)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const userDetail = doc.data();
          if (userDetail.username === username) {
            return true;
          }
          return false;
        });
      });
  };

  const updateprofile = async (e) => {
    e.preventDefault();
    setSubmited(true);
    if (!name || !username || !image || !email) {
      toast.error("Please enter required fields!");
    } else {
      setLoader(true);
      if (userExists()===true) {
        toast.error("Username already exists!");
        setLoader(false);
        return;
      }
      if (file) {
        var extension = file.name.split(".");
        const fileName =
          (Math.random() + 1).toString(36).substring(2) + "." + extension[1];
        const refdata = await firebase.storage().ref(`/users/${fileName}`);
        const uploadTask = refdata.put(file);
        uploadTask.on("state_changed", console.log, console.error, () => {
          refdata.getDownloadURL().then(async (url) => {
            if (url) {
              await firebase
                .firestore()
                .collection("UserDataModel")
                .where("walletAddress", "==", `${account}`)
                .limit(1)
                .get()
                .then(async (querySnapshot) => {
                  querySnapshot.forEach(function (doc) {
                    let tmp = doc.data();
                    let updatedObj = {
                      ...tmp,
                      name: name,
                      username: username,
                      email: email,
                      instagram: instagram ? instagram : "",
                      twitter: twitter ? twitter : "",
                      youtube: youtube ? youtube : "",
                      imageURL: url,
                    };
                    doc.ref
                      .update(updatedObj)
                      .then((result) => {
                        setLoader(false);
                        setOpen(false);
                        setUpdated(true);
                        toast.success("Profile details updated!");
                      })
                      .catch((err) => {
                        console.log("Write failed with: ", err);
                        toast.error(err.message);
                        setLoader(false);
                      });
                  });
                })
                .catch((error) => {
                  console.log(error);
                  toast.error(error.message);
                  setLoader(false);
                });
            }
          });
        });
      } else {
        await firebase
          .firestore()
          .collection("UserDataModel")
          .where("walletAddress", "==", `${account}`)
          .limit(1)
          .get()
          .then(async (querySnapshot) => {
            querySnapshot.forEach(function (doc) {
              let tmp = doc.data();
              let updatedObj = {
                ...tmp,
                name: name,
                username: username,
                email: email,
                instagram: instagram ? instagram : "",
                twitter: twitter ? twitter : "",
                youtube: youtube ? youtube : "",
              };
              doc.ref
                .update(updatedObj)
                .then((result) => {
                  setLoader(false);
                  setOpen(false);
                  setUpdated(true);
                  toast.success("Profile details updated!");
                })
                .catch((err) => {
                  console.log("Write failed with: ", err);
                  toast.error(err.message);
                  setLoader(false);
                });
            });
          })
          .catch((error) => {
            console.log(error);
            toast.error(error.message);
            setLoader(false);
          });
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
    setTwitterLink("");
    setInstagramLink("");
    setYoutubeLink("");
    setName("");
    setUserName("");
    setEmail("");
  };

  return (
    <div className="edit-profile">
      {loader && <PreloaderInner />}
      <Button onClick={() => setOpen(true)}>
        <EditIcon />
        <p>Edit Profile</p>
      </Button>
      <Dialog
        className="dialog-wrapper"
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          className="popup popup-title edit-profile-popup"
          id="responsive-dialog-title"
        >
          {"Edit Profile"}
        </DialogTitle>
        <DialogActions className="wallet-options">
          <form className="popup-form edit-form">
            <div className="form-half">
              <div
                className={
                  "profile-dragdrop-c" +
                  (isSubmited && !image ? " errorField" : "")
                }
              >
                {image && (
                  <img
                    style={{ zIndex: 10 }}
                    id="imgSelectionProfile"
                    src={image}
                  />
                )}
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  className={"form-left"}
                  style={{ zIndex: 50 }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFile(file);
                    var reader = new FileReader();
                    reader.onload = (e) => {
                      setImage(reader.result);
                    };
                    reader.onloadend = () => {
                      setImage(reader.result);
                    };
                    reader.readAsDataURL(file);
                  }}
                />
                <span
                  style={{
                    zIndex: 1,
                    textAlign: "center",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  Drop or Browse <br /> Your Picture
                </span>
              </div>
              <div>
                <input
                  type="text"
                  className={isSubmited && !name ? " errorField" : ""}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Display Name"
                />
                <input
                  className={isSubmited && !username ? " errorField" : ""}
                  type="text"
                  value={username}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="Username"
                />{" "}
                <input
                  className={isSubmited && !email ? " errorField" : ""}
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="email"
                />
                <input
                  type="text"
                  value={instagram}
                  placeholder="Instagram Link"
                  onChange={(e) => setInstagramLink(e.target.value)}
                />
                <input
                  type="text"
                  value={twitter}
                  placeholder="Twitter Link"
                  onChange={(e) => setTwitterLink(e.target.value)}
                />
                <input
                  type="text"
                  value={youtube}
                  placeholder="Youtube Link"
                  onChange={(e) => setYoutubeLink(e.target.value)}
                />
              </div>
            </div>
            <div className="popup-buttons">
              <button
                type="button"
                className="button-black"
                onClick={updateprofile}
              >
                Save
              </button>
              <button
                type="button"
                className="button-white"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </form>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditProfile;
